import React from 'react'
import { connect } from 'react-redux'

import { api, path } from '../lib'

import LoginField from '../components/LoginField'
import { SetToken } from '../actions'

class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: 'admin@noodoe.com',
      password: 'dolphinSoHandsome',
      error: '',
      loading: false,
    }
  }

  onLogin = async () => {
    try {
      this.setState({
        loading: true,
      })
      const auth = await api.mystique.post(path.USER_AUTH, {
        asp: 'ep',
        sc: 'knex',
        email: this.state.email,
        password: this.state.password,
      })
      const { token: authToken } = auth.data
  
      const signin = await api.nex.post(path.USER_SIGNIN, {}, {
        headers: {
          authorization: `Bearer ${authToken}`
        }
      })
      const { token: signInToken } = signin.data
  
      const grantAccess = await api.nex.post(path.USER_GRANT_ACCESS, {}, {
        headers: {
          authorization: `Bearer ${signInToken}`
        }
      })
      const { token } = grantAccess.data
  
      this.props.SetToken(token)

      if (this.props.qs && this.props.qs.redirect) {
        this.props.history.push(this.props.qs.redirect)
      } else {
        this.props.history.push('/')
      }

    } catch (error) {
      this.setState({
        error: error.response.data.error,
        loading: false,
      })
    }
  }

  onEmailChange = e => {
    this.setState({
      email: e.target.value,
    })
  }

  onPwdChange = e => {
    this.setState({
      password: e.target.value,
    })
  }

  render() {
    return (
      <React.Fragment>
        <LoginField error={this.state.error} loading={this.state.loading} onLogin={this.onLogin} onEmailChange={this.onEmailChange} onPwdChange={this.onPwdChange} email={this.state.email} pwd={this.state.password}/>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
})

const mapDispatchToProps = dispatch => ({
  SetToken: token => dispatch(SetToken(token))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)


// WEBPACK FOOTER //
// ./src/containers/Login.jsx